import React, { useEffect, useState } from "react";

import { MarkingLevels, Common } from "../../../helper";

import "../../../App.scss";
import "../../../assets/stlyes/MarkEditor.scss";

let j = 0;
const MarkDescription = (props) => {
  const { cards, year } = props;
  const [buttonVisiblity, setButtonVisiblity] = useState(true);
  const [selectedCards, setSelectedCards] = useState();
  const PreviousYear = () => {
    j++;
    j === totalCards.length - 1 ? setButtonVisiblity(false) : setButtonVisiblity(true);
    iterateFun(j);
  }
  let totalCards = useState(cards && cards.filter((card) => card.year <= parseInt(year)))

  const iterateFun = (j) => {
    const requiredCards = totalCards[0].sort((a, b) => b.year - a.year).slice(0, (j + 1));
    setSelectedCards(requiredCards);
    setButtonVisiblity(totalCards.length === 1 ? false : true);
  };


  useEffect(() => {
    iterateFun(j);
  }, [])

  return (
    <div className="right-content">
      <div className="explanation-cards">
        {selectedCards?.map((ele) => {
          return (<>
            <div className={ele?.year === parseInt(year) ? "greater-card" : "below-card1"}>
              <div className="title d-flex justify-content-sm-between">
                <span>Y{ele.year} {MarkingLevels.GreaterDepth}</span>
              </div>
              <div className="description">
                <p className="description-textbox">{ele.greaterDepth}</p>
              </div>
            </div>
            <div className={ele?.year === parseInt(year) ? "expected-card" : "below-card1"}>
              <div className="title d-flex justify-content-sm-between">
                <span>Y{ele.year} {MarkingLevels.Expected}</span>
              </div>
              <div className="description">
                <p className="description-textbox">{ele.expected}</p>
              </div>
            </div>
            <div className={ele?.year === parseInt(year) ? "emerging-card" : "below-card1"}>
              <div className="title d-flex justify-content-sm-between">
                <span>Y{ele.year} {MarkingLevels.WorkingTowards}</span>
              </div>
              <div className="description">
                <p className="description-textbox">{ele.emerging}</p>
              </div>
            </div>
          </>)
        })}
        <div className="below-card">
          <div className="title d-flex justify-content-sm-between">
            <span>{MarkingLevels.Below}</span>
            {j !== totalCards[0].length - 1 && buttonVisiblity && <button style={{ background: "none", color:"white", margin:"10px" }} onClick={() => PreviousYear()}>{Common.Scroll}</button>}
          </div>
        </div>
      </div>
    </div>
  )
}

export { MarkDescription };
